module.exports = __webpack_public_path__ + "resources/cdfd0160e30988fa0f6330f01c1bb710.ttf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/TradeGothic-Bold.ttf
// module id = 243
// module chunks = 0